import {
  CARBON_TAX_BRACKETS,
  BRACKET_KIND
} from '../data/brackets.js';

export function lookupCarbonBracket(emissions, brackets = CARBON_TAX_BRACKETS) {
  for (const b of brackets) {
    if (b.kind === BRACKET_KIND.UNBOUNDED_LOW) {
      if (emissions < b.upperExclusive) return b;
    } else if (b.kind === BRACKET_KIND.RANGE) {
      if (emissions >= b.min && emissions <= b.max) return b;
    } else if (b.kind === BRACKET_KIND.UNBOUNDED_HIGH) {
      if (emissions > b.lowerExclusive) return b;
    }
  }
  throw new Error(`No carbon bracket matched emissions ${emissions}`);
}

export function pickCarbonMultiplier(bracket, cop30) {
  return bracket.base >= 0 ? cop30.bonusMultiplier : cop30.penaltyMultiplier;
}

export function carbonTaxAmount(emissions, cop30, brackets) {
  const bracket = lookupCarbonBracket(emissions, brackets);
  const multiplier = pickCarbonMultiplier(bracket, cop30);
  return {
    bracket,
    base: bracket.base,
    multiplier,
    amount: bracket.base * multiplier
  };
}
